import type * as Types from '../../../../../graphql/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetChatsQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type GetChatsQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly name: string, readonly aiAgentChats: ReadonlyArray<{ readonly __typename?: 'AiAgentChat', readonly id: string, readonly title?: string | null, readonly uuid: string, readonly insertedAt: string, readonly updatedAt: string, readonly tokenUsage: { readonly __typename?: 'AiAgentTokenUsage', readonly inputTokens: number, readonly outputTokens: number } }> } | null } | null };

export type GetChatQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
  chatId: Types.Scalars['ID']['input'];
}>;


export type GetChatQueryPage = { readonly __typename?: 'RootQueryType', readonly currentUser?: { readonly __typename?: 'AccountsUser', readonly company?: { readonly __typename?: 'AccountsCompany', readonly aiAgentChat?: { readonly __typename?: 'AiAgentChat', readonly id: string, readonly title?: string | null, readonly uuid: string, readonly insertedAt: string, readonly updatedAt: string, readonly messages: ReadonlyArray<{ readonly __typename?: 'AiAgentChatMessage', readonly id: string, readonly uuid: string, readonly role: Types.AiAgentChatMessageRole, readonly content: string, readonly status: Types.AiAgentChatMessageStatus, readonly inputTokens?: number | null, readonly outputTokens?: number | null, readonly insertedAt: string }>, readonly tokenUsage: { readonly __typename?: 'AiAgentTokenUsage', readonly inputTokens: number, readonly outputTokens: number } } | null } | null } | null };


export const GetChatsDocument = gql`
    query GetChats($companyId: ID!) {
  currentUser {
    company(id: $companyId) {
      name
      aiAgentChats {
        id
        title
        uuid
        insertedAt
        updatedAt
        tokenUsage {
          inputTokens
          outputTokens
        }
      }
    }
  }
}
    `;

/**
 * __useGetChatsQuery__
 *
 * To run a query within a React component, call `useGetChatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatsQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useGetChatsQuery(baseOptions: Apollo.QueryHookOptions<GetChatsQueryPage, GetChatsQueryVariables> & ({ variables: GetChatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatsQueryPage, GetChatsQueryVariables>(GetChatsDocument, options);
      }
export function useGetChatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatsQueryPage, GetChatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatsQueryPage, GetChatsQueryVariables>(GetChatsDocument, options);
        }
export function useGetChatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatsQueryPage, GetChatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatsQueryPage, GetChatsQueryVariables>(GetChatsDocument, options);
        }
export type GetChatsQueryHookResult = ReturnType<typeof useGetChatsQuery>;
export type GetChatsLazyQueryHookResult = ReturnType<typeof useGetChatsLazyQuery>;
export type GetChatsSuspenseQueryHookResult = ReturnType<typeof useGetChatsSuspenseQuery>;
export type GetChatsQueryResult = Apollo.QueryResult<GetChatsQueryPage, GetChatsQueryVariables>;
export const GetChatDocument = gql`
    query GetChat($companyId: ID!, $chatId: ID!) {
  currentUser {
    company(id: $companyId) {
      aiAgentChat(id: $chatId) {
        id
        title
        uuid
        messages {
          id
          uuid
          role
          content
          status
          inputTokens
          outputTokens
          insertedAt
        }
        tokenUsage {
          inputTokens
          outputTokens
        }
        insertedAt
        updatedAt
      }
    }
  }
}
    `;

/**
 * __useGetChatQuery__
 *
 * To run a query within a React component, call `useGetChatQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChatQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChatQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *      chatId: // value for 'chatId'
 *   },
 * });
 */
export function useGetChatQuery(baseOptions: Apollo.QueryHookOptions<GetChatQueryPage, GetChatQueryVariables> & ({ variables: GetChatQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChatQueryPage, GetChatQueryVariables>(GetChatDocument, options);
      }
export function useGetChatLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChatQueryPage, GetChatQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChatQueryPage, GetChatQueryVariables>(GetChatDocument, options);
        }
export function useGetChatSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChatQueryPage, GetChatQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChatQueryPage, GetChatQueryVariables>(GetChatDocument, options);
        }
export type GetChatQueryHookResult = ReturnType<typeof useGetChatQuery>;
export type GetChatLazyQueryHookResult = ReturnType<typeof useGetChatLazyQuery>;
export type GetChatSuspenseQueryHookResult = ReturnType<typeof useGetChatSuspenseQuery>;
export type GetChatQueryResult = Apollo.QueryResult<GetChatQueryPage, GetChatQueryVariables>;